<template>
  <div>
    <a-modal
      :maskClosable="false"
      title="续费记录"
      :width="600"
      destroyOnClose
      :visible="visible"
      @cancel="handleCancel"
    >
      <a-table
        ref="list"
        :columns="columns"
        :rowKey="record => record.id"
        :dataSource="paylist"
      ></a-table>
      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import tenantApi from '@/api/tenant'
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      paylist:[],
      columns:[
        {
          title:'续费时间',
          customRender:(text,row)=>{
            return this.datestr(row.payTime)
          }
        },{
          title:'续费金额',
          dataIndex:'payAmount'
        },{
          title:'续费年限',
          dataIndex:'years'
        },{
          title:'支付方式',
          customRender:(text,row)=>{
            switch(row.payType){
              case 0:return '支付宝'
              case 1:return '微信'
              case 2:return '银联'
              case 3:return '其它'
            }
          }
        }
      ]
    }
  },
  methods:{
    handleCancel(){
      this.$emit('change',false)
    },
    async getPaylist(tenant){
      const rep=await tenantApi.getPayments({id:tenant.id})
      this.paylist=rep.result.items
    }
  }
}
</script>


